import React from 'react'
import EventCategory from './event_category';

var EventCategoryContainer = React.createClass({
  propTypes: {
    categories: React.PropTypes.array
  },
  render: function() {
    const { onChange, categories } = this.props;
    return(
      <div className="panel">
        <div className="panel-heading">
          <div className="panel-title"> <span className="glyphicon glyphicon-user"></span> Please select a registration category </div>
        </div>
        <div className="panel-body">
          { categories.map( (c) => <EventCategory key={c.id} onChange={onChange} { ...c} /> )}
        </div>
      </div>
    );
  }
});

export default EventCategoryContainer;


// WEBPACK FOOTER //
// ./src/components/event_category_container.js